import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { AppCommonsModule } from '../../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../../shared/pless-shared.module';
import { ImageInfoRendererModule } from '../image-info-renderer/image-info-renderer.module';

import { KYMW1407UseImageComponent } from './kymw1407-use-image.component';


/**
 * 使用画像リスト モジュール設定クラス
 *
 * @export KYMW1407UseImageModule
 * @class KYMW1407UseImageModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
    ImageInfoRendererModule,
  ],
  declarations: [
    KYMW1407UseImageComponent,
  ],
  providers: [
  ],
  exports: [
    KYMW1407UseImageComponent,
  ]
})
export class KYMW1407UseImageModule {
}
